// AUTO-GENERATED by scripts/og-images.mjs — do not edit by hand.
export const OG_IMAGES: Record<string, string> = {
  "/": "home.png",
  "/features": "features.png",
  "/pricing": "pricing.png",
  "/for-recruiting-agencies": "for-recruiting-agencies.png",
  "/recruitment-automation": "recruitment-automation.png",
  "/ai-interviews": "ai-interviews.png",
  "/resume-screening": "resume-screening.png",
  "/work-style-assessment": "work-style-assessment.png",
  "/about": "about.png",
  "/contact": "contact.png",
  "/security": "security.png",
  "/guides/what-is-an-ai-recruiting-agent": "guides-what-is-an-ai-recruiting-agent.png",
  "/integrations": "integrations.png",
  "/resources": "resources.png",
  "/faq": "faq.png",
  "/solutions/permanent-recruitment": "solutions-permanent-recruitment.png",
  "/solutions/contract-temp-staffing": "solutions-contract-temp-staffing.png",
  "/solutions/executive-search": "solutions-executive-search.png",
  "/solutions/rpo-embedded-teams": "solutions-rpo-embedded-teams.png",
  "/privacy-policy": "privacy-policy.png",
  "/terms-of-service": "terms-of-service.png",
  "/one-way-video-interviews": "one-way-video-interviews.png",
  "/candidate-screening-software": "candidate-screening-software.png",
  "/screening-cost-calculator": "screening-cost-calculator.png",
  "/mcp": "mcp.png",
  "/guides/recruiting-mcp-servers": "guides-recruiting-mcp-servers.png",
  "/guides/best-ai-recruiting-software": "guides-best-ai-recruiting-software.png",
  "/guides/recruitment-software-pricing": "guides-recruitment-software-pricing.png",
  "/guides/bullhorn-pricing": "guides-bullhorn-pricing.png",
  "/guides/recruiterflow-pricing": "guides-recruiterflow-pricing.png",
  "/guides/loxo-pricing": "guides-loxo-pricing.png",
  "/guides/zoho-recruit-pricing": "guides-zoho-recruit-pricing.png",
  "/guides/recruit-crm-pricing": "guides-recruit-crm-pricing.png",
  "/guides/manatal-pricing": "guides-manatal-pricing.png",
  "/guides/juicebox-pricing": "guides-juicebox-pricing.png",
  "/guides/spark-hire-pricing": "guides-spark-hire-pricing.png",
  "/guides/hirevue-pricing": "guides-hirevue-pricing.png",
  "/guides/greenhouse-mcp": "guides-greenhouse-mcp.png",
  "/guides/ashby-mcp": "guides-ashby-mcp.png",
  "/guides/workable-mcp": "guides-workable-mcp.png",
  "/guides/workday-mcp": "guides-workday-mcp.png",
  "/guides/bullhorn-mcp": "guides-bullhorn-mcp.png",
  "/guides/lever-mcp": "guides-lever-mcp.png",
  "/guides/how-to-start-a-staffing-agency": "guides-how-to-start-a-staffing-agency.png",
  "/guides/how-to-start-a-recruitment-agency-uk": "guides-how-to-start-a-recruitment-agency-uk.png",
  "/guides/recruitment-agency-fees": "guides-recruitment-agency-fees.png",
  "/guides/recruitment-agency-software": "guides-recruitment-agency-software.png",
  "/integrations/claude": "integrations-claude.png",
  "/integrations/chatgpt": "integrations-chatgpt.png",
  "/integrations/gemini": "integrations-gemini.png",
  "/glossary": "glossary.png",
  "/templates": "templates.png",
  "/interview-questions": "interview-questions.png",
  "/interview-questions/registered-nurse": "interview-questions-registered-nurse.png",
  "/interview-questions/certified-nursing-assistant": "interview-questions-certified-nursing-assistant.png",
  "/interview-questions/medical-assistant": "interview-questions-medical-assistant.png",
  "/interview-questions/pharmacy-technician": "interview-questions-pharmacy-technician.png",
  "/interview-questions/caregiver": "interview-questions-caregiver.png",
  "/interview-questions/administrative-assistant": "interview-questions-administrative-assistant.png",
  "/interview-questions/receptionist": "interview-questions-receptionist.png",
  "/interview-questions/customer-service-representative": "interview-questions-customer-service-representative.png",
  "/interview-questions/sales-representative": "interview-questions-sales-representative.png",
  "/interview-questions/retail-sales-associate": "interview-questions-retail-sales-associate.png",
  "/interview-questions/warehouse-associate": "interview-questions-warehouse-associate.png",
  "/interview-questions/software-engineer": "interview-questions-software-engineer.png",
  "/interview-questions/data-analyst": "interview-questions-data-analyst.png",
  "/interview-questions/it-support-specialist": "interview-questions-it-support-specialist.png",
  "/interview-questions/hr-manager": "interview-questions-hr-manager.png",
  "/interview-questions/project-manager": "interview-questions-project-manager.png",
  "/interview-questions/teacher": "interview-questions-teacher.png",
  "/interview-questions/dental-assistant": "interview-questions-dental-assistant.png",
  "/interview-questions/phlebotomist": "interview-questions-phlebotomist.png",
  "/interview-questions/executive-assistant": "interview-questions-executive-assistant.png",
  "/interview-questions/financial-analyst": "interview-questions-financial-analyst.png",
  "/interview-questions/bookkeeper": "interview-questions-bookkeeper.png",
  "/interview-questions/security-guard": "interview-questions-security-guard.png",
  "/interview-questions/electrician": "interview-questions-electrician.png",
  "/interview-questions/maintenance-technician": "interview-questions-maintenance-technician.png",
  "/interview-questions/product-manager": "interview-questions-product-manager.png",
  "/interview-questions/operations-manager": "interview-questions-operations-manager.png",
  "/interview-questions/recruiter": "interview-questions-recruiter.png",
  "/interview-questions/supervisor": "interview-questions-supervisor.png",
  "/interview-questions/business-analyst": "interview-questions-business-analyst.png",
  "/interview-questions/server": "interview-questions-server.png",
  "/interview-questions/paraprofessional": "interview-questions-paraprofessional.png",
  "/interview-questions/bartender": "interview-questions-bartender.png",
  "/interview-questions/social-worker": "interview-questions-social-worker.png",
  "/interview-questions/account-manager": "interview-questions-account-manager.png",
  "/interview-questions/nurse-practitioner": "interview-questions-nurse-practitioner.png",
  "/interview-questions/pharmacist": "interview-questions-pharmacist.png",
  "/interview-questions/case-manager": "interview-questions-case-manager.png",
  "/interview-questions/assistant-manager": "interview-questions-assistant-manager.png",
  "/interview-questions/paralegal": "interview-questions-paralegal.png",
  "/interview-questions/program-manager": "interview-questions-program-manager.png",
  "/interview-questions/bank-teller": "interview-questions-bank-teller.png",
  "/interview-questions/data-scientist": "interview-questions-data-scientist.png",
  "/interview-questions/data-engineer": "interview-questions-data-engineer.png",
  "/interview-questions/substitute-teacher": "interview-questions-substitute-teacher.png",
  "/interview-questions/special-education-teacher": "interview-questions-special-education-teacher.png",
  "/interview-questions/assistant-principal": "interview-questions-assistant-principal.png",
  "/interview-questions/preschool-teacher": "interview-questions-preschool-teacher.png",
  "/interview-questions/nurse-manager": "interview-questions-nurse-manager.png",
  "/interview-questions/emt": "interview-questions-emt.png",
  "/interview-questions/registered-behavior-technician": "interview-questions-registered-behavior-technician.png",
  "/interview-questions/accounts-payable-specialist": "interview-questions-accounts-payable-specialist.png",
  "/interview-questions/barista": "interview-questions-barista.png",
  "/interview-questions/housekeeper": "interview-questions-housekeeper.png",
  "/interview-questions/custodian": "interview-questions-custodian.png",
  "/interview-questions/hvac-technician": "interview-questions-hvac-technician.png",
  "/interview-questions/principal": "interview-questions-principal.png",
  "/interview-questions/librarian": "interview-questions-librarian.png",
  "/interview-questions/devops-engineer": "interview-questions-devops-engineer.png",
  "/interview-questions/scrum-master": "interview-questions-scrum-master.png",
  "/interview-questions/restaurant-host": "interview-questions-restaurant-host.png",
  "/interview-questions/icu-nurse": "interview-questions-icu-nurse.png",
  "/interview-questions/store-manager": "interview-questions-store-manager.png",
  "/interview-questions/event-coordinator": "interview-questions-event-coordinator.png",
  "/interview-questions/cybersecurity-analyst": "interview-questions-cybersecurity-analyst.png",
  "/interview-questions/network-engineer": "interview-questions-network-engineer.png",
  "/interview-questions/physical-therapist": "interview-questions-physical-therapist.png",
  "/interview-questions/cashier": "interview-questions-cashier.png",
  "/interview-questions/licensed-practical-nurse": "interview-questions-licensed-practical-nurse.png",
  "/interview-questions/office-manager": "interview-questions-office-manager.png",
  "/interview-questions/cook": "interview-questions-cook.png",
  "/interview-questions/accountant": "interview-questions-accountant.png",
  "/templates/phone-screening-questions": "templates-phone-screening-questions.png",
  "/templates/reference-check-questions": "templates-reference-check-questions.png",
  "/templates/competency-based-interview-questions": "templates-competency-based-interview-questions.png",
  "/templates/strengths-based-interview-questions": "templates-strengths-based-interview-questions.png",
  "/templates/interview-rubric": "templates-interview-rubric.png",
  "/templates/interview-evaluation-form": "templates-interview-evaluation-form.png",
  "/templates/ai-recruiting-policy": "templates-ai-recruiting-policy.png",
  "/templates/staffing-agency-business-plan": "templates-staffing-agency-business-plan.png",
  "/integrations/bullhorn": "integrations-bullhorn.png",
  "/integrations/vincere": "integrations-vincere.png",
  "/integrations/jobadder": "integrations-jobadder.png",
  "/integrations/greenhouse": "integrations-greenhouse.png",
  "/integrations/workable": "integrations-workable.png",
  "/alternatives": "alternatives.png",
  "/alternatives/hirevue": "alternatives-hirevue.png",
  "/alternatives/sparkhire": "alternatives-sparkhire.png",
  "/alternatives/testgorilla": "alternatives-testgorilla.png",
  "/alternatives/willo": "alternatives-willo.png",
  "/alternatives/vervoe": "alternatives-vervoe.png",
  "/alternatives/hireflix": "alternatives-hireflix.png",
  "/alternatives/vidcruiter": "alternatives-vidcruiter.png",
  "/alternatives/paradox": "alternatives-paradox.png",
  "/alternatives/interviewer-ai": "alternatives-interviewer-ai.png",
  "/alternatives/talview": "alternatives-talview.png",
  "/alternatives/metaview": "alternatives-metaview.png",
  "/alternatives/brighthire": "alternatives-brighthire.png",
  "/alternatives/myinterview": "alternatives-myinterview.png",
  "/alternatives/jobma": "alternatives-jobma.png",
  "/alternatives/harver": "alternatives-harver.png",
  "/alternatives/criteria-corp": "alternatives-criteria-corp.png",
  "/alternatives/glider-ai": "alternatives-glider-ai.png",
  "/alternatives/sapia": "alternatives-sapia.png"
};
